import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import Table from '../components/Table';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import LeadService from '../core/services/leadsService';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import toast from 'react-hot-toast';
import { Card, Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ISAAddUserModal from './ISAAddUserModal';
import { Modal, } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { format } from 'date-fns';
import { debounce, throttle } from 'lodash';
import { styled, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, CardContent, Grid } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import LinearProgress from '@mui/material/LinearProgress';
import { useMediaQuery } from '@mui/material';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import ScrollAnimation from 'react-animate-on-scroll';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import PeopleIcon from '@mui/icons-material/People';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',

}
const ISAAgents = () => {

    const getInitialButtonVisibility = () => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            return timeElapsed >= 480000;
        }
        return true;
    };
    const theme = useTheme();
    const [ICAAgents, setICAAgents] = React.useState([]);
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState(null);
    const [CountUser, setCountUser] = React.useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [rowSelection, setRowSelection] = useState({});
    const [selectedIds, setSelectedIds] = useState('');
    const [buttonVisible, setButtonVisible] = useState(getInitialButtonVisibility);
    const [emailShowTooltip, setEmailShowTooltip] = React.useState(false);
    const [isLoadingEmail, setIsLoadingEmail] = useState(false);
    const abortControllerRef = useRef(null);
    const [CountIsa, setCountIsa] = useState('');
    const [logOutModal, setLogOutModal] = React.useState(false);
    const handleDeleteOpen = (id) => {
        setOpen(true);
        setDeleteId(id);
    };

    const handleClose = () => {
        setOpen(false);
        setDeleteId(null);
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };
    const isSmallScreen = useMediaQuery('(max-width: 1366px) and (max-height: 768px)');
    const isMediumScreen = useMediaQuery('(max-width: 1920px) and (max-height: 1080px)');
    const isLargeScreen = useMediaQuery('(min-width: 1920px) and (min-height: 1080px)');
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 20,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },

        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            size: 80,
            enableSorting: false,
            muiTableHeadCellProps: {
                align: 'left',
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },
            muiTableBodyCellProps: ({ row }) => ({
                style: {
                    cursor: 'pointer', // Make it clear that it's clickable
                    color: row?.original?.deleted_at ? '#dc1919' : 'inherit', // Highlight deleted users
                    fontWeight:'bold'
                },
            }),
        },

        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            // enableClickToCopy: true,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px', // Font size based on screen size
                },
            },
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 80,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },
        },
        // {
        //     accessorKey: 'PreferredLocation',
        //     header: 'Preferred Location',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     size: 150,
        // },

        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px',  // Font size based on screen size
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '12px' : '14px', // Font size based on screen size
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return "Never Logged In";
            },
        },
        {
            id: 'actions',
            accessorKey: 'SeeMore',
            header: 'See More',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                align: 'center',
                sx: {
                    fontSize: isSmallScreen ? '11px' : isMediumScreen ? '11px' : '14px',  // Font size based on screen size
                },
            },
            Cell: ({ row }) => {
                const handleViewClick = () => {
                    if (row?.original?.deleted_at) {
                        return toast.error("This ICA user is deleted");
                    } else {
                        navigate(`/isa-agent-details/${row?.original?.id}`);
                    }
                };

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IconButton aria-label="view" onClick={handleViewClick}>
                            <VisibilityIcon />
                        </IconButton>
                        {/* <IconButton
                        aria-label="edit">
                        <EditIcon sx={{ color: '#2883CC' }} />
                    </IconButton> */}
                        {/* <IconButton
                        onClick={() => handleDeleteOpen(row?.original?.id)}
                        aria-label="delete">
                        <DeleteIcon sx={{ color: '#E71D36' }} />
                    </IconButton> */}
                    </div>
                );
            },
        },



    ], [navigate]);


    const getISAAgents = async (currentPage, searchTerm = '', signal) => {

        try {
            const selectedOrganization = '';
            setIsLoading(true)
            const res = await LeadService.getIsaAgents(currentPage, searchTerm, selectedOrganization, { signal });

            if (res?.data?.success) {
                setICAAgents(res?.data?.["isa-agents"].data);
                setCurrentPage(res?.data?.["isa-agents"].current_page);
                setTotalPages(Math.ceil(res?.data?.["isa-agents"]?.total / res?.data?.["isa-agents"].per_page));
                return;
            }

        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);

        }
    };

    // Throttled function to ensure a minimum delay of 2 seconds between calls
    const throttledGetISAAgents = useCallback(
        throttle((page, searchTerm, signal) => {
            getISAAgents(page, searchTerm, signal);
        }, 2000), []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchISA = useCallback(
        debounce((page, searchTerm) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetISAAgents(page, searchTerm, abortController.signal);
        }, 300), [throttledGetISAAgents]
    );

    useEffect(() => {
        fetchISA(currentPage, searchTerm);
        const savedSearchTerm = localStorage.getItem('searchTerm');
        if (savedSearchTerm) {
            setSearchTerm(JSON.parse(savedSearchTerm));
        }
    }, [currentPage, searchTerm, fetchISA]);

    const handleClear = () => {
        localStorage.removeItem('searchTerm');
        setSearchTerm('');
        setCurrentPage(1);
        fetchISA(1, '');
    };

    const handleSearchChange = (event) => {
        const newSearchValue = event.target.value;
        setSearchTerm(newSearchValue);
        if (newSearchValue !== null) {
            localStorage.setItem('searchTerm', JSON.stringify(newSearchValue));
        } else {
            localStorage.removeItem('searchTerm');
        }
        setCurrentPage(1);
    };

    const getCountData = async () => {
        try {
            const res = await LeadService.TotalAllCountData();
            if (res?.data?.success) {
                setCountUser(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    const CountOrgAdmin = async () => {
        try {
            const resp = await LeadService.CountAgentAndCustomerOrgAdmin();
            if (resp?.data?.success) {
                setCountIsa(resp?.data);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };
    const iconMap = {
        'Total ICA Count': <PeopleIcon style={{ color: '#3674c4', fontSize: '35px', }} />,
        'Total Active ICA Count': <EmojiPeopleIcon style={{ color: '#3674c4', fontSize: '35px', }} />,
    };

    useEffect(() => {
        getCountData();
        CountOrgAdmin();
    }, []);

    useEffect(() => {
        const emailSentTimestamp = localStorage.getItem('emailSentTimestamp');
        if (emailSentTimestamp) {
            const timeElapsed = Date.now() - parseInt(emailSentTimestamp, 10);
            if (timeElapsed < 480000) { // If less than 2 minutes have passed
                setButtonVisible(false);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000 - timeElapsed);
            }
        }
    }, []);

    const handleEmailSend = async () => {
        const selectedIds = Object.keys(rowSelection).map(key => parseInt(key));
        if (selectedIds.length == 0) {
            return toast.error('Please select any users to send email');
        }

        try {
            setIsLoadingEmail(true);
            setButtonVisible(false);
            const res = await LeadService.EmailToAgents(selectedIds);
            setIsLoadingEmail(false);
            if (res?.data?.success) {
                toast.success(res.data.message);

                await setSelectedIds('');
                setRowSelection({});
                const timestamp = Date.now();
                localStorage.setItem('emailSentTimestamp', timestamp);
                setTimeout(() => {
                    setButtonVisible(true);
                    localStorage.removeItem('emailSentTimestamp');
                }, 480000);
                return;
            }
        } catch (error) {
            toast.error(error.message)
            console.error(error);
        }
    };

    return (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingEmail && <LinearProgress />}</div>
            <ScrollAnimation animateIn='fadeIn'>
                <div>
                    <Grid container spacing={2}>
                        {[
                            { label: 'Total ICA Count', value: CountIsa?.totalICA },
                            { label: 'Total Active ICA Count', value: CountIsa?.totalActiveICA },

                        ]?.map((item, index) => (
                            <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
                                <Card
                                    sx={{
                                        borderRadius: '20px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        background: 'linear-gradient(#26c7f3, #316ec1)',
                                    }}
                                >
                                    <CardContent>
                                        <Box style={{ padding: '15px' }}>
                                            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <Avatar
                                                    sx={{
                                                        bgcolor: '#fff',
                                                        width: { xs: '30px', sm: '50px', md: '50px', lg: '60px' },
                                                        height: { xs: '30px', sm: '50px', md: '50px', lg: '60px' },
                                                    }}
                                                >
                                                    {iconMap[item?.label]}
                                                </Avatar>
                                                <Typography
                                                    sx={{
                                                        fontSize: { xs: '20px', sm: '24px' }, // Responsive font sizes
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        fontFamily: 'inherit',
                                                    }}
                                                >
                                                    {item?.value}
                                                </Typography>
                                            </Box>
                                            <Box style={{ marginTop: '20px' }}>
                                                <Typography sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, color: 'white', fontWeight: 'bold', fontFamily: 'inherit', }}>{item?.label}</Typography>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
                        <div>
                            <Typography style={{ fontSize: '36px', fontWeight: '700' }}>ICA Users</Typography>
                        </div>
                        <div style={{ display: 'flex', gap: "15px" }}>
                            <>
                                {buttonVisible && (
                                    <div style={{ marginTop: '10px', position: 'relative' }} onClick={handleEmailSend} >
                                        <Button style={{ cursor: 'pointer' }}
                                            onMouseEnter={() => setEmailShowTooltip(true)}
                                            onMouseLeave={() => setEmailShowTooltip(false)}
                                        >
                                            <ForwardToInboxIcon />
                                            {emailShowTooltip && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        bottom: '100%',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                        color: '#fff',
                                                        padding: '5px 10px',
                                                        borderRadius: '5px',
                                                        fontSize: '11px',
                                                        whiteSpace: 'nowrap',
                                                        marginBottom: '12px'
                                                    }}
                                                >
                                                    Send login Credential
                                                </div>
                                            )}
                                        </Button>

                                    </div>
                                )}</>

                            {/* <ISAAddUserModal
                                getISAAgents={getISAAgents}
                                getCountData={getCountData}
                            /> */}
                        </div>
                    </div>
                    {/* <Table column={column} data={ICAAgents} /> */}
                    <ThemeProvider theme={theme}>
                        <GlobalStyles
                            styles={{
                                '::-webkit-scrollbar': {
                                    width: '14px', // Set the desired width for the scrollbar
                                },
                                '::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                    borderRadius: '10px', // Set the border radius for a rounded effect
                                },
                            }}
                        />
                        <div style={{ width: '100%', overflow: 'visible', }}>
                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                                <TextField
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder="Search by name , email"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClear}
                                                    aria-label="clear search"
                                                >
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}

                                />
                            </Box>
                            <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
                                <MaterialReactTable
                                    columns={columns}
                                    data={ICAAgents}
                                    state={{ rowSelection, isLoading: isLoading }}
                                    muiCircularProgressProps={{
                                        color: 'secondary',
                                        thickness: 5,
                                        size: 55,
                                    }}
                                    muiSkeletonProps={{
                                        animation: 'pulse',
                                        height: 28,
                                    }}
                                    enablePagination={false}
                                    enableTopToolbar={true}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    showSkeletons={false}
                                    enableRowSelection={(row) => {
                                        return !row?.original?.deleted_at;
                                    }}
                                    onRowSelectionChange={setRowSelection}
                                    getRowId={(row) => row?.id}
                                    enableColumnFilterModes={false}
                                    enableColumnActions={false}
                                    enableColumnOrdering={false}
                                    enableFullScreenToggle={false}
                                    enableColumnFilters={false}
                                    enableGlobalFilter={false}
                                    initialState={{
                                        showColumnFilters: false,
                                        showGlobalFilter: false,
                                    }}

                                    muiTableBodyRowProps={{
                                        sx: {
                                            backgroundColor: '#f5f5f5', // Default row background color
                                            '&:nth-of-type(odd)': {
                                                backgroundColor: '#ffffff', // Alternate rows with white
                                            },
                                            '&:hover': {
                                                backgroundColor: '#e0e0e0', // Hover effect
                                                cursor: 'pointer'
                                            },
                                        },
                                    }}
                                />
                            </Card>

                            <Pagination
                                count={totalPages}
                                color="primary"
                                page={currentPage}
                                onChange={(event, value) => setCurrentPage(value)}
                                style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                            />
                        </div>
                    </ThemeProvider>
                    <Modal
                        open={open}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <div style={{ marginTop: '20px', position: 'relative' }}>
                                <Box sx={{
                                    display: 'grid',
                                    padding: '10px',
                                    gap: '10px',
                                }}>
                                    <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                        <Box>
                                            <DeleteIcon style={{ fontSize: '34px' }} />
                                        </Box>
                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                            <div>
                                                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this user?</span>
                                            </div>
                                            <div>
                                                <span style={{ fontSize: '16px', color: '#252F46' }}>This action will delete this user permanently, and you can not undo this.</span>
                                            </div>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                    <Button
                                        onClick={handleClose}
                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: 'white',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: '#252F46',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button

                                        style={{
                                            width: '140px',
                                            height: '43px',
                                            backgroundColor: '#5379BD',
                                            fontWeight: '500',
                                            borderRadius: '4px',
                                            border: ' 1px solid #587DBF',
                                            color: 'white',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </Box>
                            </div>
                        </Box>
                    </Modal>

                </div>
            </ScrollAnimation>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />

        </>
    );
};

export default ISAAgents;
